import React, { Component } from 'react';

class LatestNewsSection extends Component{
	render(){
		
		return(
			<>
				
				<section className="section-sp1 service-wraper2">
					<div className="container">
						<div className="row">
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">30+</h2>
									<h5 className="ttr-title">Years Combined Experience</h5>
									<p>Trust our 30+ years of experience for your lasting oral health and peace of mind.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">3</h2>
									<h5 className="ttr-title">Awards</h5>
									<p>Experience award-winning care for a healthier, more radiant smile.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">3</h2>
									<h5 className="ttr-title">Doctors</h5>
									<p>You're in safe hands at our dental office, where a team of three experienced doctors collaborates to provide top-notch care, ensuring all your dental needs are expertly met.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">250+</h2>
									<h5 className="ttr-title">5-Star Reviews</h5>
									<p>Join our thriving community of satisfied patients who trust us for exceptional dental care and have rated us with 250+ 5-star reviews.</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				
			</>
		);
	}
}

export default LatestNewsSection;